var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiPresetSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.275,
    height: 11.201,
    viewBox: "0 0 13.275 11.201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.62,2.339a.311.311,0,0,0-.441,0L1.528,3.981.939,3.407a.311.311,0,0,0-.441,0l-.407.408a.311.311,0,0,0,0,.441L1.325,5.485a.331.331,0,0,0,.457,0l.4-.4L4.058,3.208a.313.313,0,0,0,0-.441Zm0,4.127a.311.311,0,0,0-.441,0L1.528,8.119.939,7.546a.311.311,0,0,0-.441,0l-.407.407a.311.311,0,0,0,0,.441L1.322,9.625a.331.331,0,0,0,.456,0l.407-.407L4.058,7.346a.311.311,0,0,0,0-.438ZM1.659,10.96a1.245,1.245,0,1,0,0,2.489,1.245,1.245,0,1,0,0-2.489Zm11.2.415H5.393a.415.415,0,0,0-.415.415v.83a.415.415,0,0,0,.415.415H12.86a.415.415,0,0,0,.415-.415v-.83A.415.415,0,0,0,12.86,11.375Zm0-8.3H5.393a.415.415,0,0,0-.415.415v.83a.415.415,0,0,0,.415.415H12.86a.415.415,0,0,0,.415-.415v-.83A.415.415,0,0,0,12.86,3.078Zm0,4.148H5.393a.415.415,0,0,0-.415.415v.83a.415.415,0,0,0,.415.415H12.86a.415.415,0,0,0,.415-.415v-.83A.415.415,0,0,0,12.86,7.227Z",
    transform: "translate(0 -2.248)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiPresetSmall);
export default __webpack_public_path__ + "static/media/si_preset_small.eba9243248e57417629045194d0dec4e.svg";
export { ForwardRef as ReactComponent };